import { render } from "./homeActivity.vue?vue&type=template&id=24897dc8"
import script from "./homeActivity.vue?vue&type=script&lang=js"
export * from "./homeActivity.vue?vue&type=script&lang=js"

import "./homeActivity.vue?vue&type=style&index=0&id=24897dc8&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__